import script from "./AiWorkflowAuthor.vue?vue&type=script&setup=true&lang=js"
export * from "./AiWorkflowAuthor.vue?vue&type=script&setup=true&lang=js"

import "./AiWorkflowAuthor.vue?vue&type=style&index=0&id=0c45fcc3&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/91znxra3/0/cs/cs-manager-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c45fcc3"]])

export default __exports__